import { FEATURES } from 'collaboration-sidebar';
export const ENABLED_COLLABORATION_FEATURES = [FEATURES.COMMENTS, FEATURES.TASKS, FEATURES.CALENDAR];
export const ContentTypeCollabSidebarAppName = {
  ['landing-page']: 'content-detail-landing-page',
  ['site-page']: 'content-detail-site-page'
};